import { useEffect, useState } from 'react';
import { getAgentConfig } from '../lib/api/agents';
import { agentConfig } from '../mocks/agentDetail';

function useAgentConfig(agentId) {
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    getAgentConfig(agentId)
      .then((data) => {
        if (!cancelled) setConfig(data);
      })
      .catch(() => {
        // No backend yet — mocks are the interim API contract.
        if (!cancelled) setConfig(agentConfig(agentId));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [agentId]);

  return { config, setConfig, isLoading };
}

export default useAgentConfig;
